import { aboutData } from '@/mocks/homeData';

export default function About() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 text-xs font-medium bg-primary-100 text-primary-700 rounded-full mb-3 whitespace-nowrap">
            <i className="ri-information-line mr-1"></i>了解我们
          </span>
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950">
            关于本站
          </h2>
        </div>

        <div className="max-w-4xl mx-auto bg-background-100 border border-background-200/60 rounded-xl p-6 md:p-8">
          <p className="text-sm md:text-base text-foreground-700 leading-relaxed">
            {aboutData.content}
          </p>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5 mt-8">
            {aboutData.highlights.map((item) => (
              <div
                key={item.label}
                className="text-center p-4 rounded-lg bg-background-50 border border-background-200/40"
              >
                <div className="w-10 h-10 md:w-11 md:h-11 mx-auto flex items-center justify-center rounded-lg bg-primary-100">
                  <i className={`${item.icon} text-primary-600 text-lg`}></i>
                </div>
                <div className="mt-3 font-semibold text-sm text-foreground-900 whitespace-nowrap">{item.label}</div>
                <div className="mt-1 text-xs text-foreground-500 leading-snug">{item.desc}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}